
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("3KGVP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d18ebc68320409fe$export$2e2bcd8739ae039);

var $2jDha = parcelRequire("2jDha");

var $axKFq = parcelRequire("axKFq");

var $1RFT0 = parcelRequire("1RFT0");

var $knPb9 = parcelRequire("knPb9");

var $2hox0 = parcelRequire("2hox0");

var $lbttE = parcelRequire("lbttE");

var $fz8wa = parcelRequire("fz8wa");

var $WE1Mo = parcelRequire("WE1Mo");

var $1uW3Y = parcelRequire("1uW3Y");

var $e4aUt = parcelRequire("e4aUt");
var /* Using withAnalyticsEvents HOC instead of ComponentWithAnalytics so we can fire on the
 * navigation channel and add actionSubjectId and attributes easily.
 * The withAnalyticsEvents HOC must wrap keyboardShortcuts first so it does not override any injected
 * props. */ $d18ebc68320409fe$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $2jDha.default)({
    showSearch: (createAnalyticsEvent)=>(0, $1RFT0.keyboardShortcutPressed)({
            createAnalyticsEvent: createAnalyticsEvent,
            id: 'quickSearch',
            key: '/'
        }),
    showIssueCreate: (createAnalyticsEvent)=>(0, $1RFT0.keyboardShortcutPressed)({
            createAnalyticsEvent: createAnalyticsEvent,
            id: 'createIssue',
            key: 'c'
        }),
    navigateToIssueSearch: (createAnalyticsEvent)=>(0, $1RFT0.keyboardShortcutPressed)({
            createAnalyticsEvent: createAnalyticsEvent,
            id: 'findIssues',
            key: 'g i'
        }),
    navigateToMostRecentProject: (createAnalyticsEvent)=>(0, $1RFT0.keyboardShortcutPressed)({
            createAnalyticsEvent: createAnalyticsEvent,
            id: 'browseToProject',
            key: 'g p'
        })
})((0, $e4aUt.default)), {
    navigateToIssueSearch: $WE1Mo.navigateToIssueSearch,
    navigateToMostRecentProject: $WE1Mo.navigateToMostRecentProject,
    ApplicationPermissionsSubscriber: $fz8wa.ApplicationPermissionsSubscriber,
    KeyboardShortcutsDialog: $1uW3Y.KeyboardShortcutsDialog,
    ProjectCreateDrawerConsumer: $lbttE.ProjectCreateDrawerConsumer,
    Shortcuts: $axKFq.CommandShortcuts,
    NavUIControllerSubscriber: $2hox0.UIControllerSubscriber
});

});
parcelRegister("axKFq", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $cc0f6b42d78d14cf$export$7ff7e4fe85a5960a);

var $eUqFw = parcelRequire("eUqFw");

var $fmmnJ = parcelRequire("fmmnJ");

var $awzwr = parcelRequire("awzwr");

var $6jiFZ = parcelRequire("6jiFZ");

var $9aFSa = parcelRequire("9aFSa");
const $cc0f6b42d78d14cf$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $eUqFw.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $6jiFZ.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $eUqFw.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awzwr.RegisterCommands), {
        registrationId: (0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("awzwr", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $42c02b036374b0c2$export$cd555833c78729f1);

var $eUqFw = parcelRequire("eUqFw");

var $7ElYg = parcelRequire("7ElYg");
const $42c02b036374b0c2$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ElYg.RegisterCommandsWithRegistry), props);

});
parcelRegister("7ElYg", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $f8fb4bce96babd2d$export$b8955a01360d2876);

var $fqCN8 = parcelRequire("fqCN8");
function $f8fb4bce96babd2d$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $fqCN8.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});


parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $WBLbN = parcelRequire("WBLbN");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $WBLbN.createHook)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = false ? new (0, $70s4u.Subject)() : (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});

parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});



parcelRegister("1RFT0", function(module, exports) {

$parcel$export(module.exports, "keyboardShortcutPressed", () => $07ce1d1304b9ed6e$export$32c6c6b79f098d3);
$parcel$export(module.exports, "productNavigationExpandedCollapsed", () => $07ce1d1304b9ed6e$export$e2ad10d5be2f2400);
/**
 * This file contains analytics functions related to navigation keyboard shortcuts.
 * We are firing events on the navigation fabric channel to align with the other events
 * specified in https://hello.atlassian.net/wiki/spaces/PData/pages/140331306/Minimum+Event+Spec+-+Navigation
 * These functions are used in both nav v1 and nav v2 at the moment with a long term goal of moving global navigation
 * keyboard shortcuts within atlaskit itself.
 */ 
var $6PJBT = parcelRequire("6PJBT");
const $07ce1d1304b9ed6e$export$32c6c6b79f098d3 = ({ createAnalyticsEvent: createAnalyticsEvent, id: id, key: key, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'keyboardShortcut',
        actionSubjectId: id,
        attributes: {
            navVersion: window.__NAV_VERSION__ || 'UNKNOWN',
            key: key,
            ...attributes
        }
    }).fire((0, $6PJBT.FabricChannel).navigation);
};
const $07ce1d1304b9ed6e$export$e2ad10d5be2f2400 = ({ createAnalyticsEvent: createAnalyticsEvent, isCollapsed: isCollapsed })=>{
    createAnalyticsEvent({
        action: isCollapsed ? 'expanded' : 'collapsed',
        actionSubject: 'productNavigation',
        attributes: {
            trigger: 'keyboardShortcut'
        }
    }).fire((0, $6PJBT.FabricChannel).navigation);
};

});

parcelRegister("2hox0", function(module, exports) {

$parcel$export(module.exports, "UIControllerSubscriber", () => $b52525162b6724ab$export$8e3db525e646de2c);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $9zysr = parcelRequire("9zysr");

var $kpmC0 = parcelRequire("kpmC0");

var $7JTqr = parcelRequire("7JTqr");

var $iP6ac = parcelRequire("iP6ac");
// Nav3
const $b52525162b6724ab$var$UIControllerSubscriberOld = ({ children: children })=>{
    const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $kpmC0.useLeftSidebarController)();
    const { isCollapsed: isCollapsed, width: width } = (0, $kpmC0.useLeftSidebarState)();
    const stateRef = (0, $eUqFw.useRef)({
        state: {
            isCollapsed: isCollapsed,
            isResizing: false,
            isResizeDisabled: false,
            productNavWidth: width
        },
        collapse: collapseLeftSidebar,
        expand: expandLeftSidebar,
        toggleCollapse: ()=>isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()
    });
    const navigationUIController = (0, $eUqFw.useMemo)(()=>({
            state: {
                isCollapsed: isCollapsed,
                isResizing: false,
                isResizeDisabled: false,
                productNavWidth: width
            },
            collapse: collapseLeftSidebar,
            expand: expandLeftSidebar,
            toggleCollapse: ()=>isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()
        }), [
        collapseLeftSidebar,
        expandLeftSidebar,
        isCollapsed,
        width
    ]);
    stateRef.current = Object.assign(stateRef.current, navigationUIController);
    return children(stateRef.current);
};
const $b52525162b6724ab$var$defaultState = {
    state: {
        isCollapsed: false,
        isResizing: false,
        isResizeDisabled: false,
        productNavWidth: 0
    },
    collapse: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    expand: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    toggleCollapse: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
// Nav4
const $b52525162b6724ab$var$UIControllerSubscriberNew = ({ children: children })=>{
    const toggleSideNav = (0, $iP6ac.useToggleSideNav)();
    const stateRef = (0, $eUqFw.useRef)({
        ...$b52525162b6724ab$var$defaultState,
        toggleCollapse: toggleSideNav
    });
    const navigationUIController = (0, $eUqFw.useMemo)(()=>({
            ...$b52525162b6724ab$var$defaultState,
            toggleCollapse: toggleSideNav
        }), [
        toggleSideNav
    ]);
    stateRef.current = Object.assign(stateRef.current, navigationUIController);
    return children(stateRef.current);
};
const $b52525162b6724ab$export$8e3db525e646de2c = (0, $9zysr.componentWithCondition)((0, $7JTqr.getWillShowNav4), $b52525162b6724ab$var$UIControllerSubscriberNew, $b52525162b6724ab$var$UIControllerSubscriberOld);

});

parcelRegister("WE1Mo", function(module, exports) {

$parcel$export(module.exports, "ISSUE_SEARCH_PATH", () => $910dc98c07492a35$export$160e2509706f1f3d);
$parcel$export(module.exports, "navigateToIssueSearch", () => $910dc98c07492a35$export$722548870edd83a4);
$parcel$export(module.exports, "navigateToMostRecentProject", () => $910dc98c07492a35$export$6e7d070c02020dbd);

var $lRmyA = parcelRequire("lRmyA");
const $910dc98c07492a35$export$160e2509706f1f3d = '/issues/';
const $910dc98c07492a35$export$722548870edd83a4 = ()=>window.open($910dc98c07492a35$export$160e2509706f1f3d, '_self');
const $910dc98c07492a35$export$6e7d070c02020dbd = ()=>(0, $lRmyA.performGetRequest)('/rest/internal/2/productsearch/search?type=projects').then((data)=>{
        // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
        const section = data.find(({ id: id })=>id === 'quick-search-projects');
        if (section && section.items && section.items[0] && section.items[0].url) window.open(section.items[0].url, '_self');
    });

});

parcelRegister("1uW3Y", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcutsDialog", () => $25bf49bbb8999b18$export$dc5d1c021e0a8741);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $25bf49bbb8999b18$var$KeyboardShortcutsDialogLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("hrKi2")), {
    ssr: false,
    moduleId: "./src/packages/common/components/keyboard-shortcuts-dialog/src/index.tsx"
});
const $25bf49bbb8999b18$export$dc5d1c021e0a8741 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "integrations.keyboard-shortcuts-dialog",
        packageName: "jira-keyboard-shortcuts",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "keyboard-shortcuts.dialog",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($25bf49bbb8999b18$var$KeyboardShortcutsDialogLazy, props)));

});
parcelRegister("hrKi2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("vZJTw").then(()=>parcelRequire('5PkhS'));

});


parcelRegister("e4aUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $df34b0e486ddc802$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gO9Xw = parcelRequire("gO9Xw");

var $cSu9v = parcelRequire("cSu9v");

var $f4oGi = parcelRequire("f4oGi");

var $eQuyQ = parcelRequire("eQuyQ");

var $9zALC = parcelRequire("9zALC");

var $gIIkx = parcelRequire("gIIkx");

var $jmejm = parcelRequire("jmejm");

var $gfXKy = parcelRequire("gfXKy");

var $1RFT0 = parcelRequire("1RFT0");

var $eI5EY = parcelRequire("eI5EY");

var $f2Poq = parcelRequire("f2Poq");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $kAiYS = parcelRequire("kAiYS");

var $7JTqr = parcelRequire("7JTqr");

var $SEaoU = parcelRequire("SEaoU");

var $WE1Mo = parcelRequire("WE1Mo");


var $iUV1N = parcelRequire("iUV1N");

var $56eCS = parcelRequire("56eCS");
// eslint-disable-next-line jira/react/no-class-components
class $df34b0e486ddc802$var$KeyboardShortcuts extends (0, $eUqFw.Component) {
    getKeyMap({ toggleHelpPanel: toggleHelpPanel, openKeyboardShortcutsDialog: openKeyboardShortcutsDialog, toggleCollapse: toggleCollapse, isNextGen: isNextGen }) {
        const { navigateToIssueSearch: navigateToIssueSearch, navigateToMostRecentProject: navigateToMostRecentProject, showIssueCreate: showIssueCreate, showSearch: showSearch, shouldUseHelpShortcut: shouldUseHelpShortcut, formatMessage: formatMessage, getKeywords: getKeywords } = this.props;
        const keys = isNextGen === true ? {
            '?': {
                callback: openKeyboardShortcutsDialog,
                registerInCommandPalette: {
                    name: formatMessage((0, $iUV1N.default).keyboardShortcutsCommandPalette),
                    keywords: getKeywords('viewKeyboardShortcutsSynonyms'),
                    priority: (0, $9zALC.COMMAND_PALETTE_HELP_PRIORITY).viewKeyboardShortcuts,
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).help,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4oGi))), {
                                label: formatMessage((0, $iUV1N.default).keyboardShortcutsCommandPalette)
                            })
                    },
                    analytics: {
                        action: (0, $43e5db31f2699c3a$export$e0515b3bb1ce3f33)
                    },
                    ...(0, $eI5EY.fg)('compal-ktlo-improvements-1') ? {
                        id: 'keyboard-shortcuts.open'
                    } : {}
                }
            },
            '/': {
                callback: showSearch
            },
            '[': {
                callback: toggleCollapse
            },
            escape: {
                // taken care of by the @atlaskit/drawer component itself
                // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                callback: ()=>{}
            },
            'g p': {
                callback: ()=>navigateToMostRecentProject()
            },
            'g i': {
                callback: ()=>navigateToIssueSearch(),
                registerInCommandPalette: this.props.hideAndTransformNavigationCommand({
                    command: {
                        id: 'find-issues',
                        name: formatMessage((0, $iUV1N.default).viewAllIssues),
                        keywords: getKeywords('viewAllIssuesSynonyms'),
                        priority: (0, $9zALC.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).viewAllIssues,
                        section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).siteNavigation,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                                    label: formatMessage((0, $iUV1N.default).viewAllIssues)
                                })
                        },
                        analytics: {
                            action: (0, $43e5db31f2699c3a$export$5f007fc3736b8e2b)
                        }
                    },
                    hideCommandPath: (0, $WE1Mo.ISSUE_SEARCH_PATH),
                    path: (0, $WE1Mo.ISSUE_SEARCH_PATH)
                })
            },
            c: {
                callback: showIssueCreate,
                registerInCommandPalette: {
                    name: formatMessage((0, $iUV1N.default).createIssue),
                    keywords: getKeywords('createIssueSynonyms'),
                    priority: (0, $jmejm.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).createIssue,
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).quickActions,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                                label: formatMessage((0, $iUV1N.default).createIssue)
                            })
                    },
                    analytics: {
                        action: (0, $43e5db31f2699c3a$export$4e353cf4f7beb2cd)
                    },
                    ...(0, $eI5EY.fg)('compal-ktlo-improvements-1') ? {
                        id: 'keyboard-shortcuts.create-issue'
                    } : {}
                }
            },
            ...shouldUseHelpShortcut && __SPA__ ? {
                h: {
                    callback: toggleHelpPanel,
                    registerInCommandPalette: {
                        name: formatMessage((0, $iUV1N.default).getHelp),
                        keywords: getKeywords('getHelpSynonyms'),
                        priority: (0, $9zALC.COMMAND_PALETTE_HELP_PRIORITY).getHelp,
                        section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).help,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQuyQ))), {
                                    label: formatMessage((0, $iUV1N.default).getHelp)
                                })
                        },
                        analytics: {
                            action: (0, $43e5db31f2699c3a$export$42dbd0c9d165bb55)
                        },
                        ...(0, $eI5EY.fg)('compal-ktlo-improvements-1') ? {
                            id: 'keyboard-shortcuts.help'
                        } : {}
                    }
                }
            } : null
        } : {
            '/': {
                callback: showSearch,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).quickSearch)
            },
            escape: {
                // taken care of by the @atlaskit/drawer component itself
                // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                callback: ()=>{},
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).closeDrawer)
            },
            c: {
                callback: showIssueCreate,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).createIssue),
                registerInCommandPalette: {
                    name: formatMessage((0, $iUV1N.default).createIssue),
                    keywords: getKeywords('createIssueSynonyms'),
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).quickActions,
                    priority: (0, $jmejm.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).createIssue,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                                label: formatMessage((0, $iUV1N.default).createIssue)
                            })
                    },
                    analytics: {
                        action: (0, $43e5db31f2699c3a$export$4e353cf4f7beb2cd)
                    },
                    ...(0, $eI5EY.fg)('compal-ktlo-improvements-1') ? {
                        id: 'keyboard-shortcuts.create-issue'
                    } : {}
                }
            },
            '?': {
                callback: openKeyboardShortcutsDialog,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).keyboardShortcuts),
                registerInCommandPalette: {
                    name: formatMessage((0, $iUV1N.default).keyboardShortcutsCommandPalette),
                    keywords: getKeywords('viewKeyboardShortcutsSynonyms'),
                    priority: (0, $9zALC.COMMAND_PALETTE_HELP_PRIORITY).viewKeyboardShortcuts,
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).help,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4oGi))), {
                                label: formatMessage((0, $iUV1N.default).keyboardShortcutsCommandPalette)
                            })
                    },
                    analytics: {
                        action: (0, $43e5db31f2699c3a$export$e0515b3bb1ce3f33)
                    },
                    ...(0, $eI5EY.fg)('compal-ktlo-improvements-1') ? {
                        id: 'keyboard-shortcuts.open'
                    } : {}
                }
            },
            'g i': {
                callback: ()=>navigateToIssueSearch(),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).findIssues),
                registerInCommandPalette: this.props.hideAndTransformNavigationCommand({
                    command: {
                        id: 'find-issues',
                        name: formatMessage((0, $iUV1N.default).viewAllIssues),
                        keywords: getKeywords('viewAllIssuesSynonyms'),
                        priority: (0, $9zALC.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).viewAllIssues,
                        section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).siteNavigation,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                                    label: formatMessage((0, $iUV1N.default).viewAllIssues)
                                })
                        },
                        analytics: {
                            action: (0, $43e5db31f2699c3a$export$5f007fc3736b8e2b)
                        }
                    },
                    hideCommandPath: (0, $WE1Mo.ISSUE_SEARCH_PATH),
                    path: (0, $WE1Mo.ISSUE_SEARCH_PATH)
                })
            },
            'g p': {
                callback: ()=>navigateToMostRecentProject(),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).browseAProject)
            },
            '[': {
                callback: toggleCollapse,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).toggleSidebar)
            },
            ...shouldUseHelpShortcut && __SPA__ ? {
                h: {
                    callback: toggleHelpPanel,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).openHelpPanel),
                    registerInCommandPalette: {
                        name: formatMessage((0, $iUV1N.default).getHelp),
                        keywords: getKeywords('getHelpSynonyms'),
                        priority: (0, $9zALC.COMMAND_PALETTE_HELP_PRIORITY).getHelp,
                        section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).help,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQuyQ))), {
                                    label: formatMessage((0, $iUV1N.default).getHelp)
                                })
                        },
                        analytics: {
                            action: (0, $43e5db31f2699c3a$export$42dbd0c9d165bb55)
                        },
                        ...(0, $eI5EY.fg)('compal-ktlo-improvements-1') ? {
                            id: 'keyboard-shortcuts.help'
                        } : {}
                    }
                }
            } : null,
            [`${(0, $56eCS.getShortcutModifierKey)()}+k`]: {
                // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                callback: ()=>{},
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).openCommandPalette),
                priority: -1 // this keyboard shortcut is only registered here to show up in the helper dialog. Its registration is in @atlassian/jira-command-palette-integration
            }
        };
        return keys;
    }
    createToggleCollapse(navAPI) {
        return ()=>{
            if ((0, $7JTqr.getWillShowNav4)()) {
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                const { state: { isCollapsed: isCollapsed }, toggleCollapse: toggleCollapse } = navAPI;
                (0, $1RFT0.keyboardShortcutPressed)({
                    createAnalyticsEvent: createAnalyticsEvent,
                    id: 'expandCollapseSidebar',
                    key: '['
                });
                (0, $1RFT0.productNavigationExpandedCollapsed)({
                    createAnalyticsEvent: createAnalyticsEvent,
                    isCollapsed: isCollapsed
                });
                toggleCollapse();
            } else {
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                const { state: { isCollapsed: isCollapsed }, toggleCollapse: toggleCollapse } = navAPI;
                const contextualNavigation = document.querySelector('[data-testid="ContextualNavigation"]');
                // @ts-expect-error - TS2339 - Property 'style' does not exist on type 'Element'.
                const isVisible = contextualNavigation && contextualNavigation.style.width !== '0px';
                if (isVisible === true) {
                    (0, $1RFT0.keyboardShortcutPressed)({
                        createAnalyticsEvent: createAnalyticsEvent,
                        id: 'expandCollapseSidebar',
                        key: '['
                    });
                    (0, $1RFT0.productNavigationExpandedCollapsed)({
                        createAnalyticsEvent: createAnalyticsEvent,
                        isCollapsed: isCollapsed
                    });
                    toggleCollapse();
                }
            }
        };
    }
    createToggleHelpPanel(isNextGen) {
        return ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, toggleHelpPanel: toggleHelpPanel } = this.props;
            (0, $1RFT0.keyboardShortcutPressed)({
                createAnalyticsEvent: createAnalyticsEvent,
                id: 'openHelpPanel',
                key: 'h',
                attributes: {
                    helpPanelVersion: (0, $f2Poq.HELP_PANEL_VERSION),
                    helpPanelType: 'inProductHelp',
                    nextGenProject: isNextGen
                }
            });
            toggleHelpPanel();
        };
    }
    createOpenKeyboardShortcutsDialog(openDialog) {
        return ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            (0, $1RFT0.keyboardShortcutPressed)({
                createAnalyticsEvent: createAnalyticsEvent,
                id: 'keyboardShortcuts',
                key: '?'
            });
            openDialog();
        };
    }
    render() {
        const { ApplicationPermissionsSubscriber: ApplicationPermissionsSubscriber, KeyboardShortcutsDialog: KeyboardShortcutsDialog, ProjectCreateDrawerConsumer: ProjectCreateDrawerConsumer, Shortcuts: Shortcuts, NavUIControllerSubscriber: NavUIControllerSubscriber } = this.props;
        return(// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApplicationPermissionsSubscriber, null, ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectCreateDrawerConsumer, null, ({ data: { isOpen: isOpen } })=>isOpen ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kAiYS.ModalsContainer), {
                    scope: "keyboard-shortcuts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kAiYS.ModalsSubscriber), null, (isKeyboardShortcutsDialogOpen, { open: open, close: close })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $SEaoU.ContainerContextSubscriber), null, ({ data: contextData })=>{
                        const isNextGen = contextData && contextData.contextType === 'project' ? contextData.project.isSimplified : false;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isKeyboardShortcutsDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(KeyboardShortcutsDialog, {
                            isOpen: true,
                            onDialogDismissed: close,
                            applicationPermissionData: data.applicationPermissions,
                            isNextGen: isNextGen,
                            shouldUseHelpShortcut: true
                        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NavUIControllerSubscriber, null, (navAPI)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Shortcuts, {
                                isSpa: __SPA__,
                                label: isNextGen ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iUV1N.default).globalShortcuts),
                                keyMap: this.getKeyMap({
                                    toggleHelpPanel: this.createToggleHelpPanel(isNextGen),
                                    openKeyboardShortcutsDialog: this.createOpenKeyboardShortcutsDialog(open),
                                    toggleCollapse: this.createToggleCollapse(navAPI),
                                    isNextGen: isNextGen
                                })
                            })));
                    }))))));
    }
}
const $df34b0e486ddc802$export$89fa8f7790ea1f0e = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { hideAndTransformNavigationCommand: hideAndTransformNavigationCommand } = (0, $gIIkx.useTransformNavigationCommands)();
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df34b0e486ddc802$var$KeyboardShortcuts, {
        formatMessage: formatMessage,
        hideAndTransformNavigationCommand: hideAndTransformNavigationCommand,
        getKeywords: getKeywords,
        ...props
    });
};
var $df34b0e486ddc802$export$2e2bcd8739ae039 = $df34b0e486ddc802$export$89fa8f7790ea1f0e;

});
parcelRegister("gO9Xw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3c90a7e02e55e7e$var$_react = $c3c90a7e02e55e7e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $c3c90a7e02e55e7e$var$_add = $c3c90a7e02e55e7e$var$_interopRequireDefault((parcelRequire("cS2gQ")));
function $c3c90a7e02e55e7e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c3c90a7e02e55e7e$var$AddIcon = (props)=>/*#__PURE__*/ $c3c90a7e02e55e7e$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $c3c90a7e02e55e7e$var$_add.default
    }));
$c3c90a7e02e55e7e$var$AddIcon.displayName = 'AddIcon';
var $c3c90a7e02e55e7e$var$_default = module.exports.default = $c3c90a7e02e55e7e$var$AddIcon;

});

parcelRegister("cSu9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9601eacac1d33448$var$_react = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9601eacac1d33448$var$_arrowRight = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("gTPnA")));
function $9601eacac1d33448$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9601eacac1d33448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $9601eacac1d33448$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $9601eacac1d33448$var$_arrowRight.default
    }));
$9601eacac1d33448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $9601eacac1d33448$var$_default = module.exports.default = $9601eacac1d33448$var$ArrowRightIcon;

});
parcelRegister("gTPnA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d3ba36590232c43c6ebd269f57604960>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4d9a34bffd519bc$var$_react = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c4d9a34bffd519bc$var$_UNSAFE_baseNew = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c4d9a34bffd519bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4d9a34bffd519bc$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c4d9a34bffd519bc$var$_react.default.createElement($c4d9a34bffd519bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$c4d9a34bffd519bc$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c4d9a34bffd519bc$var$_default = module.exports.default = $c4d9a34bffd519bc$var$ArrowRightIcon;

});


parcelRegister("f4oGi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af8a5fe38412111b$var$_react = $af8a5fe38412111b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $af8a5fe38412111b$var$_textStyle = $af8a5fe38412111b$var$_interopRequireDefault((parcelRequire("9nFKt")));
function $af8a5fe38412111b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $af8a5fe38412111b$var$EmojiKeyboardIcon = (props)=>/*#__PURE__*/ $af8a5fe38412111b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m5.84 6.95-3.82 9.97a.5.5 0 0 0 .47.68H3.7a.5.5 0 0 0 .47-.33l.68-1.88a.5.5 0 0 1 .47-.33h3.8a.5.5 0 0 1 .47.33l.68 1.88a.5.5 0 0 0 .47.33h1.27a.5.5 0 0 0 .47-.68L8.69 6.95a.7.7 0 0 0-.66-.45H6.49a.7.7 0 0 0-.65.45m1.57 2.46 1.25 3.41a.2.2 0 0 1-.19.27h-2.5a.2.2 0 0 1-.19-.27l1.25-3.41a.2.2 0 0 1 .38 0m10.14 6.46c1.22 0 2.14-1.01 2.14-2.6s-.9-2.53-2.14-2.53c-1.26 0-2.18.94-2.18 2.53 0 1.58.9 2.6 2.18 2.6m2.16.6c-.37.83-1.28 1.43-2.44 1.43-2.57 0-4.27-2-4.27-4.64 0-2.55 1.66-4.57 4.2-4.57 1.56 0 2.28.83 2.5 1.33v-.34c0-.25.01-.39.21-.58q.21-.18.62-.16h.76a.58.58 0 0 1 .5.17c.21.2.19.42.19.58v6.39q0 .34.02.9 0 .29-.12.43a.63.63 0 0 1-.51.24h-.93c-.19 0-.45-.08-.53-.18s-.16-.23-.18-.53a6 6 0 0 1-.01-.36z"/></svg>`
    }, props, {
        newIcon: $af8a5fe38412111b$var$_textStyle.default
    }));
$af8a5fe38412111b$var$EmojiKeyboardIcon.displayName = 'EmojiKeyboardIcon';
var $af8a5fe38412111b$var$_default = module.exports.default = $af8a5fe38412111b$var$EmojiKeyboardIcon;

});
parcelRegister("9nFKt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c36d9538ae355f3b15448880d69da07>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d46a57315b78985$var$_react = $6d46a57315b78985$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $6d46a57315b78985$var$_UNSAFE_baseNew = $6d46a57315b78985$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $6d46a57315b78985$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d46a57315b78985$var$TextStyleIcon = (props)=>/*#__PURE__*/ $6d46a57315b78985$var$_react.default.createElement($6d46a57315b78985$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.75 11v-.375L5.032 7.25M12.25 11v-.375L10.974 7.25m0 0L8.518.75H7.5l-2.468 6.5m5.942 0H5.032"/>`
    }, props));
$6d46a57315b78985$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $6d46a57315b78985$var$_default = module.exports.default = $6d46a57315b78985$var$TextStyleIcon;

});


parcelRegister("eQuyQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aceda0cfde73f17b$var$_react = $aceda0cfde73f17b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $aceda0cfde73f17b$var$_questionCircle = $aceda0cfde73f17b$var$_interopRequireDefault((parcelRequire("8MkOl")));
function $aceda0cfde73f17b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $aceda0cfde73f17b$var$QuestionIcon = (props)=>/*#__PURE__*/ $aceda0cfde73f17b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18a1 1 0 0 1 0-2 1 1 0 0 1 0 2m-2-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path d="M15.89 8.048a3.97 3.97 0 0 0-2.951-2.94A4.005 4.005 0 0 0 8 9.087l.009.008 1.878.022.112-.116A2 2 0 0 1 12 7c1.103 0 2 .897 2 2s-.897 2-2 2h.008a1 1 0 0 0-.998.987v2.014a1 1 0 1 0 2 0v-.782c0-.217.145-.399.349-.472a3.99 3.99 0 0 0 2.53-4.699"/></g></svg>`
    }, props, {
        newIcon: $aceda0cfde73f17b$var$_questionCircle.default
    }));
$aceda0cfde73f17b$var$QuestionIcon.displayName = 'QuestionIcon';
var $aceda0cfde73f17b$var$_default = module.exports.default = $aceda0cfde73f17b$var$QuestionIcon;

});

parcelRegister("gIIkx", function(module, exports) {

$parcel$export(module.exports, "useTransformNavigationCommands", () => $2a846d5538aecfbb$export$5b108cd54c923a60);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $hGcnP = parcelRequire("hGcnP");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $6jiFZ = parcelRequire("6jiFZ");

var $LddR2 = parcelRequire("LddR2");

var $8FbYY = parcelRequire("8FbYY");

var $gCtL7 = parcelRequire("gCtL7");

var $igOBb = parcelRequire("igOBb");

var $jMP2a = parcelRequire("jMP2a");

var $8rQuz = parcelRequire("8rQuz");

var $lB25E = parcelRequire("lB25E");

var $8A5Pc = parcelRequire("8A5Pc");

var $4HIA6 = parcelRequire("4HIA6");

var $1Uuz9 = parcelRequire("1Uuz9");

var $duyJV = parcelRequire("duyJV");

const $2a846d5538aecfbb$export$5b108cd54c923a60 = ()=>{
    const [{ location: { pathname: pathname } }, { push: push, pushTo: pushTo }] = (0, $lB25E.useRouter)();
    const { getAnalyticsAttributes: getAnalyticsAttributes } = (0, $gCtL7.useActionsCommandPalette)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const openNewTab = (0, $eUqFw.useCallback)((link, openBackground)=>{
        const url = typeof link === 'string' ? link : link.path;
        const newTab = window.open(url, '_blank');
        if (openBackground) {
            newTab?.blur();
            window.focus();
        }
        return newTab;
    }, []);
    const openSameTab = (0, $eUqFw.useCallback)((link)=>{
        if (typeof link === 'string') return push(link);
        return pushTo(link);
    }, [
        push,
        pushTo
    ]);
    const renderCommand = (0, $eUqFw.useCallback)((props, path, shouldAlwaysOpenNewTab)=>{
        const { onClick: onClick, ...rest } = props;
        const { command: command } = rest;
        const handleClick = (event)=>{
            const wasSecondaryTriggered = (0, $8FbYY.isSecondaryTrigger)(event);
            if (!wasSecondaryTriggered) {
                onClick?.(event); // Run main action as it will close the modal too
                event.preventDefault();
                return;
            }
            const analytics = getAnalyticsAttributes(command, 'mouse', wasSecondaryTriggered, props?.analyticsAttributes);
            const eventAnalytics = createAnalyticsEvent({});
            (0, $jMP2a.fireTrackAnalytics)(eventAnalytics, 'commandPalette navigation', analytics);
            (0, $jMP2a.fireTrackAnalytics)(eventAnalytics, 'commandPalette secondaryAction', {
                ...analytics,
                keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                secondaryAction: 'openNewTab'
            });
            (0, $jMP2a.fireTrackAnalytics)(eventAnalytics, 'commandPalette taskSucceeded', analytics);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4HIA6.NavigationLink), {
            to: path,
            onClick: handleClick,
            ...shouldAlwaysOpenNewTab && {
                target: '_blank'
            },
            "data-testid": (0, $f3c17e0f83ec4de3$export$8db96ea7b6a4cbab),
            tabIndex: -1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LddR2.components).CommandRow, rest));
    }, [
        createAnalyticsEvent,
        getAnalyticsAttributes
    ]);
    const transformNavigationCommand = (0, $eUqFw.useCallback)((command, { path: path, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab })=>({
            ...command,
            components: {
                ...command.components,
                Name: (base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8A5Pc.NameContainer), null, command.components?.Name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.Name, base) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, command.name), !!shouldAlwaysOpenNewTab && (0, $8rQuz.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                        testId: (0, $f3c17e0f83ec4de3$export$99957d8f5f113509),
                        justifyContent: "center",
                        alignItems: "center",
                        xcss: $2a846d5538aecfbb$var$iconWrapperStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hGcnP))), {
                        label: "",
                        color: "currentColor"
                    })), !!shouldAlwaysOpenNewTab && !(0, $8rQuz.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8A5Pc.IconContainer), {
                        "data-testid": (0, $f3c17e0f83ec4de3$export$99957d8f5f113509)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hGcnP))), {
                        label: "",
                        color: "currentColor"
                    }))),
                CommandRow: (base)=>renderCommand(base, path, shouldAlwaysOpenNewTab),
                Footer: (0, $1Uuz9.NewTabHintMessage)
            },
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>shouldAlwaysOpenNewTab ? openNewTab(path) : openSameTab(path)
            },
            secondaryAction: {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>openNewTab(path, true),
                preventModalClose: true,
                analyticsArgs: {
                    secondaryAction: 'openNewTab'
                }
            }
        }), [
        openNewTab,
        openSameTab,
        renderCommand
    ]);
    const shouldShowCommand = (0, $eUqFw.useCallback)((hideCommandPath)=>!(0, $duyJV.isCurrentPage)(hideCommandPath, pathname), [
        pathname
    ]);
    const hideAndTransformNavigationCommand = (0, $eUqFw.useCallback)((commandToTransform)=>{
        const { path: path, hideCommandPath: hideCommandPath, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab, command: command } = commandToTransform;
        let hidePath = typeof path === 'string' ? path : path.path;
        if (hideCommandPath) hidePath = hideCommandPath;
        if (!shouldShowCommand(hidePath)) return undefined;
        return transformNavigationCommand(command, {
            path: path,
            shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab
        });
    }, [
        shouldShowCommand,
        transformNavigationCommand
    ]);
    const hideAndTransformNavigationCommands = (0, $eUqFw.useCallback)((commands)=>{
        const filteredCommands = [];
        commands.forEach((commandToTransform)=>{
            const transformedCommand = hideAndTransformNavigationCommand(commandToTransform);
            if (transformedCommand) filteredCommands.push(transformedCommand);
        });
        return filteredCommands;
    }, [
        hideAndTransformNavigationCommand
    ]);
    return {
        shouldShowCommand: shouldShowCommand,
        hideAndTransformNavigationCommand: hideAndTransformNavigationCommand,
        hideAndTransformNavigationCommands: hideAndTransformNavigationCommands,
        transformNavigationCommand: transformNavigationCommand
    };
};
const $2a846d5538aecfbb$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    height: '24px',
    width: '24px',
    marginLeft: 'space.075'
});

});
parcelRegister("hGcnP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fc1a335133771545e71093f73ae7c48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cdeff6f7a5b7fded$var$_react = $cdeff6f7a5b7fded$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cdeff6f7a5b7fded$var$_linkExternal = $cdeff6f7a5b7fded$var$_interopRequireDefault((parcelRequire("1yh1n")));

var $cdeff6f7a5b7fded$var$_shortcut = $cdeff6f7a5b7fded$var$_interopRequireDefault((parcelRequire("23NQ5")));
function $cdeff6f7a5b7fded$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LinkExternalIcon.
 * This component is LinkExternalIcon, with `UNSAFE_fallbackIcon` set to "ShortcutIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cdeff6f7a5b7fded$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $cdeff6f7a5b7fded$var$_react.default.createElement($cdeff6f7a5b7fded$var$_linkExternal.default, Object.assign({
        LEGACY_fallbackIcon: $cdeff6f7a5b7fded$var$_shortcut.default
    }, props));
$cdeff6f7a5b7fded$var$LinkExternalIcon.Name = 'LinkExternalIconMigration';
var $cdeff6f7a5b7fded$var$_default = module.exports.default = $cdeff6f7a5b7fded$var$LinkExternalIcon;

});

parcelRegister("LddR2", function(module, exports) {

$parcel$export(module.exports, "components", () => $de43b6bd284ffa0f$export$9b5ac10f59f76296);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $73ZV3 = parcelRequire("73ZV3");

var $gwWoQ = parcelRequire("gwWoQ");

var $b4qUd = parcelRequire("b4qUd");

var $48xUp = parcelRequire("48xUp");
const $de43b6bd284ffa0f$var$NameComponent = ({ children: children, ...rest })=>{
    if ((0, $eI5EY.fg)('fix_compal_name_wrapper')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), rest, children);
};
const $de43b6bd284ffa0f$export$9b5ac10f59f76296 = {
    CommandRow: $gwWoQ.CommandRow,
    Name: $de43b6bd284ffa0f$var$NameComponent,
    LeftIcon: (0, $eUqFw.Fragment),
    Wrapper: (0, $eUqFw.Fragment),
    Footer: $b4qUd.Footer,
    Body: (0, $73ZV3.CommandPaletteBody),
    Header: $48xUp.Header
};

});
parcelRegister("73ZV3", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteBody", () => $d0ddd4262a5c5e52$export$b1023de69a8756e6);
$parcel$export(module.exports, "NoResultsContainer", () => $d0ddd4262a5c5e52$export$2ab569a6937cb4e4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $bFzGY = parcelRequire("bFzGY");

var $bKxX9 = parcelRequire("bKxX9");

var $eI5EY = parcelRequire("eI5EY");

var $gCtL7 = parcelRequire("gCtL7");

var $8FbYY = parcelRequire("8FbYY");

var $5IPbY = parcelRequire("5IPbY");

var $80x7h = parcelRequire("80x7h");

var $f9a4v = parcelRequire("f9a4v");

var $1c3Ul = parcelRequire("1c3Ul");

var $985MX = parcelRequire("985MX");

var $dDiRc = parcelRequire("dDiRc");

var $4PPUt = parcelRequire("4PPUt");
const $d0ddd4262a5c5e52$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, expandedCommand: expandedCommand, search: search, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, executeCommand: executeCommand, removeCommandsById: removeCommandsById }] = (0, $gCtL7.useCommandPalette)();
    const [prevActiveIndex, setPrevActiveIndex] = (0, $eUqFw.useState)(activeIndex);
    const onHoverCommand = (index)=>{
        if (index === undefined) return;
        setActiveIndex(index);
    };
    const onClickCommand = (0, $eUqFw.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'mouse',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $8FbYY.getAnalyticsAttributesFromResult)(result),
                ...(0, $8FbYY.getRegistryData)(registry, activeRegistry, result?.command.id)
            }
        }, (0, $8FbYY.isSecondaryTrigger)(event));
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    const onMouseDownCommand = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const resultsRefs = (0, $eUqFw.useRef)([]);
    const modalBodyRef = (0, $eUqFw.useRef)(null);
    const onArrowScroll = (0, $eUqFw.useCallback)((newActiveIndex)=>{
        setActiveIndex(newActiveIndex);
    }, [
        setActiveIndex
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
        setPrevActiveIndex(activeIndex);
        const scrollTo = activeIndex > prevActiveIndex ? (0, $dDiRc.SCROLL_DIRECTION).END : (0, $dDiRc.SCROLL_DIRECTION).START;
        const scrollToIndex = (0, $4PPUt.getScrollToIndex)(results, activeIndex, scrollTo);
        const scrolledToResult = resultsRefs.current[scrollToIndex];
        if (scrolledToResult && !(0, $4PPUt.isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
            const lastIndex = results.length - 1;
            const firstIndex = results.findIndex((result)=>!result.isGroup);
            if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
            else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
            else (0, $4PPUt.scrollResultIntoView)(scrolledToResult, scrollTo);
        }
    }, [
        activeIndex,
        prevActiveIndex,
        results
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!modalBodyRef.current?.scrollTo) return;
        modalBodyRef.current.scrollTo(0, 0);
    }, [
        expandedCommand,
        search
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isSearchFieldFocused) return ()=>{};
        const handleArrowScroll = (ev)=>{
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                activeIndex > 0 && onArrowScroll(activeIndex - 1);
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
            }
        };
        window.addEventListener('keydown', handleArrowScroll);
        return ()=>{
            window.removeEventListener('keydown', handleArrowScroll);
        };
    }, [
        isSearchFieldFocused,
        total,
        activeIndex,
        setActiveIndex,
        onArrowScroll
    ]);
    const noResultsFallback = (0, $eUqFw.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
        fallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9a4v.CommandPaletteSearchResultListWrapper), {
        ref: modalBodyRef,
        ...(0, $eI5EY.fg)('a11y_violations_fixes') && {
            noResultsFallback: noResultsFallback
        }
    }, !loadingList && noResultsFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ddd4262a5c5e52$export$2ab569a6937cb4e4, {
        "data-testid": (0, $dDiRc.NO_RESULTS_TEST_ID)
    }, noResultsFallback), results.map((result, index)=>{
        if (result.isGroup) {
            let GroupContainerComponent;
            if ((0, $bKxX9.ff)('compal-issue-actions-very-high-priority_f5w5r')) GroupContainerComponent = $d0ddd4262a5c5e52$var$GroupContainerAfterToken;
            else GroupContainerComponent = $d0ddd4262a5c5e52$var$GroupContainerOld;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5IPbY.CommandPaletteSearchResultGroupItem), {
                ref: (commandRef)=>{
                    if (commandRef) resultsRefs.current[index] = commandRef;
                },
                group: result.group,
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(GroupContainerComponent, {
                "data-testid": (0, $dDiRc.GROUP_TEST_ID),
                isFirstResult: index === 0
            }, result.renderGroup ? result.renderGroup() : result.group));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $985MX.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $8FbYY.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80x7h.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) resultsRefs.current[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1c3Ul.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        })));
    }), renderAfterCommands?.({}));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0ddd4262a5c5e52$var$GroupContainerOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $9t7rW.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _k48p1nn1 _syaz1wmz _1p1dangw _1yt41f6d",
            __cmplp.className
        ])
    });
});
const $d0ddd4262a5c5e52$var$GroupContainerAfterToken = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $9t7rW.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81oud _vwz41kw7 _syaz1wmz _1yt41f6d",
            __cmplp.className
        ])
    });
});
const $d0ddd4262a5c5e52$export$2ab569a6937cb4e4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _syaz1e9r _1yt4wd81",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5IPbY", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", () => $43e423a37776a525$export$591c26128e5fd757);

var $eUqFw = parcelRequire("eUqFw");

const $43e423a37776a525$export$591c26128e5fd757 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ group: group, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-testid": (0, $d08d4eae9e022dcf$export$617744f059bfc3ba),
        id: group ? `${0, $d08d4eae9e022dcf$export$f24a36b1556217a1}-${group}` : undefined,
        ...rest
    }));

});
const $d08d4eae9e022dcf$export$5758a25d98c7bb27 = 'compal-listbox';
const $d08d4eae9e022dcf$export$f61172db5aff4b22 = `${$d08d4eae9e022dcf$export$5758a25d98c7bb27}-item`;
const $d08d4eae9e022dcf$export$f24a36b1556217a1 = `${$d08d4eae9e022dcf$export$5758a25d98c7bb27}-group`;
const $d08d4eae9e022dcf$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $d08d4eae9e022dcf$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $d08d4eae9e022dcf$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $d08d4eae9e022dcf$export$65eac2e53f304ab6 = 'compal-listbox-screen-reader';


parcelRegister("80x7h", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListItem", () => $55b21d7cef5b1dbb$export$1f8fa9d1eef77b32);

var $eUqFw = parcelRequire("eUqFw");

const $55b21d7cef5b1dbb$export$1f8fa9d1eef77b32 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ id: id, active: active, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-testid": (0, $d08d4eae9e022dcf$export$617744f059bfc3ba),
        role: "option",
        id: `${(0, $d08d4eae9e022dcf$export$f61172db5aff4b22)}-${id}`,
        "aria-selected": active,
        ...rest
    }));

});

parcelRegister("f9a4v", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", () => $d3691614f8dde395$export$95554f6fb39a83c2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");


var $ezG3R = parcelRequire("ezG3R");
const $d3691614f8dde395$export$95554f6fb39a83c2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ noResultsFallback: noResultsFallback, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3691614f8dde395$var$Wrapper, {
        "data-testid": (0, $d08d4eae9e022dcf$export$85eefac753ab5bdb),
        id: (0, $d08d4eae9e022dcf$export$5758a25d98c7bb27),
        role: noResultsFallback && (0, $eI5EY.fg)('a11y_violations_fixes') ? 'group' : 'listbox',
        ref: ref,
        "aria-label": formatMessage((0, $ezG3R.messages).commandPaletteSearchResultListBoxLabel),
        ...props
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3691614f8dde395$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71l4u42 _18m91wug _vchhusvi _1yt41bpf _1e0c1txw _2lx21bp4 _zulp1b66 _1tke8vuz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ezG3R", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dae431d5b55d597f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $dae431d5b55d597f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    commandPaletteSearchResultListBoxLabel: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
        "defaultMessage": "List of commands"
    }
});

});


parcelRegister("1c3Ul", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $673add314e0db490$export$3ef5d254c3c573e3);

var $eUqFw = parcelRequire("eUqFw");

var $8FbYY = parcelRequire("8FbYY");

var $gwWoQ = parcelRequire("gwWoQ");
const $673add314e0db490$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
    const { command: command } = result;
    const isActive = !!(result.active && isSearchFieldFocused);
    const isFirstCommand = result.index === 0;
    const rowProps = {
        index: index,
        isActive: isActive,
        command: command,
        isFirstCommand: isFirstCommand,
        onMouseMove: onHoverCommand,
        onClick: onClickCommand,
        onMouseDown: onMouseDownCommand,
        analyticsAttributes: (0, $8FbYY.getAnalyticsAttributesFromResult)(result)
    };
    if (command.components?.CommandRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.CommandRow, rowProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwWoQ.CommandRow), rowProps);
};

});
parcelRegister("gwWoQ", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $6e9750c220ca1b53$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $8rQuz = parcelRequire("8rQuz");

var $5t8Df = parcelRequire("5t8Df");


var $8LHLg = parcelRequire("8LHLg");

var $7cPAX = parcelRequire("7cPAX");
const $6e9750c220ca1b53$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
    const InnerContainer = $6e9750c220ca1b53$var$CommandContainerInner;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandContainerWrapper, {
        "data-testid": command.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandContainer, {
        index: index,
        active: isActive,
        "data-active": isActive,
        "data-testid": (0, $d665202372e0655f$export$b0017db5728101cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InnerContainer, {
        "data-testid": (0, $d665202372e0655f$export$47c379a40b00a339),
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandLeftIconAndNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandIconsContainer, {
        "data-testid": (0, $d665202372e0655f$export$d6dd1cf63aae711c)
    }, command.components?.LeftIcon && ((0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        testId: (0, $d665202372e0655f$export$7b41978523c7dd4a),
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $6e9750c220ca1b53$var$iconStyles,
            isActive && $6e9750c220ca1b53$var$iconActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.LeftIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandLeftIconContainer, {
        "data-testid": (0, $d665202372e0655f$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.LeftIcon, null))), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5t8Df.OutlinedLozenge), {
        "data-testid": (0, $d665202372e0655f$export$72c5368f559dd523)
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8LHLg.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cPAX.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e9750c220ca1b53$var$CommandContainerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81oud _syazjjyb _1yt4swc3",
            !!__cmplp.active && "_syazaj1x _bfhk29zg _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus194a",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandContainerInner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt467l7 _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandIconsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1b66 _zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$iconStyles = (0, $1ZAYh.xcss)({
    width: '24px',
    height: '24px',
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration, but requires bigger change in types.
    color: 'color.icon.subtle'
});
const $6e9750c220ca1b53$var$iconActiveStyles = (0, $1ZAYh.xcss)({
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration.
    color: 'color.icon'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e9750c220ca1b53$var$CommandLeftIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
            __cmplp.active ? "_syaz2zfp" : "_syazbkuv",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandLeftIconAndNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _16jlkb7n _1o9zkb7n _i0dlf1ug _vwz41tcg _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
const $d665202372e0655f$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $d665202372e0655f$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $d665202372e0655f$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $d665202372e0655f$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $d665202372e0655f$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';

parcelRegister("8LHLg", function(module, exports) {

$parcel$export(module.exports, "RenderCommandName", () => $6ee7061fe3a2c77e$export$931d3f1d35f6c058);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gIpo4 = parcelRequire("gIpo4");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");


var $8rQuz = parcelRequire("8rQuz");

var $jCRsd = parcelRequire("jCRsd");

const $6ee7061fe3a2c77e$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
    const renderCommandName = (0, $eUqFw.useCallback)(()=>{
        if (command.components?.Name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.Name, {
            isActive: isActive
        }, command.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jCRsd.TruncateWithTooltipOnActive), {
            isActive: isActive
        }, command.name);
    }, [
        command,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandNameContainer, {
        "data-testid": (0, $1095276f0211050b$export$1858c2a91b8b53ba),
        active: isActive
    }, command.breadcrumb?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandBreadcrumbContainer, {
        "data-testid": (0, $1095276f0211050b$export$5e3a644e2bbe06f3)
    }, command.breadcrumb.map((BreadCrumb, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandBreadcrumbItem, {
            isParent: index !== arr.length - 1,
            "data-testid": (0, $1095276f0211050b$export$fb5462105b23e3e5),
            active: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BreadCrumb, {
            isActive: isActive
        })), index !== arr.length - 1 && ((0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            justifyContent: "center",
            xcss: $6ee7061fe3a2c77e$var$iconWrapperStyles,
            alignItems: "center",
            testId: (0, $1095276f0211050b$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gIpo4))), {
            color: "currentColor",
            label: "separator"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandChevronContainer, {
            "data-testid": (0, $1095276f0211050b$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gIpo4))), {
            color: "currentColor",
            label: "separator"
        })))))) : renderCommandName());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ee7061fe3a2c77e$var$CommandNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _vwz41tcg",
            __cmplp.active ? "_syaz1qfn" : "_syaz1a45",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandBreadcrumbContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandBreadcrumbItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_zek046": (0, $9t7rW.default)(__cmplp.active ? `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N400})` : `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N200})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !!__cmplp.isParent && "_syaz1bu1",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4kb7n _syazjwct",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    height: '24px',
    width: '24px'
});

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

parcelRegister("jCRsd", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnActive", () => $57c74f3e056e4b78$export$4495aca3d261add0);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lcnyw = parcelRequire("lcnyw");

var $lXgc2 = parcelRequire("lXgc2");


var $lDcdk = parcelRequire("lDcdk");
const $57c74f3e056e4b78$var$TooltipRenderer = ({ children: children, shouldShowTooltip: shouldShowTooltip })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: !!shouldShowTooltip,
        autoFocus: false,
        placement: "bottom-end",
        popupComponent: (0, $lXgc2.PopupComponent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TriggerComponent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                ...triggerProps
            }),
        zIndex: (0, $lcnyw.layers).tooltip()
    });
const $57c74f3e056e4b78$export$70f47de153e915ed = ()=>(0, $eUqFw.useRef)(null);
const $57c74f3e056e4b78$export$4495aca3d261add0 = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
    const containerRef = $57c74f3e056e4b78$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $lDcdk.useTruncatedTooltip)({
        containerRef: containerRef,
        tooltipDelay: (0, $79f2d7e0eace9088$export$f9e3e7ede9ba929d)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: containerRef,
        xcss: [
            $57c74f3e056e4b78$var$tooltipContainerStyles,
            !preventTruncate && $57c74f3e056e4b78$var$truncateTooltipStyles
        ]
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57c74f3e056e4b78$var$TooltipRenderer, {
        shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
    }, showTooltip && customTooltip ? customTooltip : children));
};
const $57c74f3e056e4b78$var$tooltipContainerStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    flexGrow: 1,
    textTransform: 'none'
});
const $57c74f3e056e4b78$var$truncateTooltipStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("lXgc2", function(module, exports) {

$parcel$export(module.exports, "TooltipComponent", () => $50856cc63ccf025e$export$e18e2f8e82cdc428);
$parcel$export(module.exports, "TriggerComponent", () => $50856cc63ccf025e$export$534fc570264a52a4);
$parcel$export(module.exports, "TooltipTrigger", () => $50856cc63ccf025e$export$8c610744efcf8a1d);
$parcel$export(module.exports, "PopupComponent", () => $50856cc63ccf025e$export$9fac2d040f3ed438);
$parcel$export(module.exports, "TruncateWithTooltipContainer", () => $50856cc63ccf025e$export$8cae238d61c8405a);
$parcel$export(module.exports, "TooltipContent", () => $50856cc63ccf025e$export$e9003e2be37ec060);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $g3tFP = parcelRequire("g3tFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1SWMO = parcelRequire("1SWMO");
const $50856cc63ccf025e$export$e18e2f8e82cdc428 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$var$StyledTooltipPrimitive, {
        ...props,
        ref: ref
    }));
const $50856cc63ccf025e$export$534fc570264a52a4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$export$8c610744efcf8a1d, {
        ...props,
        role: "button",
        ref: ref,
        "aria-label": formatMessage((0, $1SWMO.messages).tooltipTriggerAriaLabel)
    });
});
const $50856cc63ccf025e$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$var$StyledPopupPrimitive, {
        ...props,
        ref: ref
    }, children)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50856cc63ccf025e$var$StyledTooltipPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $g3tFP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50856cc63ccf025e$var$StyledPopupPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $50856cc63ccf025e$export$8cae238d61c8405a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1p1dglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $50856cc63ccf025e$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1jfi _11c8qk37",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1SWMO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ce912c60a1269c55$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ce912c60a1269c55$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    tooltipTriggerAriaLabel: {
        "id": "command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label",
        "defaultMessage": "Command palette tool tip"
    }
});

});


const $79f2d7e0eace9088$export$f9e3e7ede9ba929d = 400;

parcelRegister("lDcdk", function(module, exports) {

$parcel$export(module.exports, "useTruncatedTooltip", () => $8c918be484ad3aec$export$94b118b3187f12c);

var $eUqFw = parcelRequire("eUqFw");

var $8FbYY = parcelRequire("8FbYY");
const $8c918be484ad3aec$export$22c0312879c61300 = ()=>(0, $eUqFw.useState)(false);
const $8c918be484ad3aec$export$1ac6e474a0163418 = ()=>(0, $eUqFw.useState)(false);
const $8c918be484ad3aec$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
    const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $8c918be484ad3aec$export$22c0312879c61300();
    const [isTruncated, setIsTruncated] = $8c918be484ad3aec$export$1ac6e474a0163418();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $8FbYY.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    (0, $eUqFw.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
        else setIsTruncated(false);
    }, [
        setIsTruncated,
        containerRef
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isTruncated && tooltipDelay === 0) {
            setShouldShowTruncatedTooltip(true);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (isTruncated && tooltipDelay > 0) {
            setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        setShouldShowTruncatedTooltip(false);
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        isTruncated,
        setShouldShowTruncatedTooltip,
        tooltipDelay,
        setTimeoutFunc
    ]);
    return {
        shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
    };
};

});


const $1095276f0211050b$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $1095276f0211050b$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $1095276f0211050b$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $1095276f0211050b$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';


parcelRegister("7cPAX", function(module, exports) {

$parcel$export(module.exports, "RightContent", () => $b3a3550b1d4e6bec$export$11dbab4b39f15d6b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dwj4T = parcelRequire("dwj4T");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8FbYY = parcelRequire("8FbYY");


var $hBQBI = parcelRequire("hBQBI");

var $iMtOt = parcelRequire("iMtOt");

var $6gNFs = parcelRequire("6gNFs");

var $cAOzG = parcelRequire("cAOzG");
const $b3a3550b1d4e6bec$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const transitionStep = (0, $6gNFs.useHoverTransitionStep)(command, isActive, isFirstCommand);
    const commandHasChildren = (0, $eUqFw.useMemo)(()=>(0, $8FbYY.hasChildren)(command), [
        command
    ]);
    const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
    if (!shouldRenderRightContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$RightContentWrapper, null, commandHasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$CommandRightChevronContainer, {
        "data-testid": (0, $d5b555147cabbe39$export$e3e144c17be58a44),
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
        label: formatMessage((0, $hBQBI.messages).rightChevronLabel)
    })), !!command.shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$ShortcutContainer, {
        "data-testid": (0, $d5b555147cabbe39$export$f3036e9d26f81cd9),
        shouldHaveTransition: commandHasChildren,
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMtOt.Shortcuts), {
        shortcut: command.shortcut
    })));
};
const $b3a3550b1d4e6bec$var$animationFadeIn = null;
const $b3a3550b1d4e6bec$var$animationFadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$RightContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1a45",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$CommandRightChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _vwz41tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syazbkuv",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$ShortcutContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});

const $d5b555147cabbe39$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $d5b555147cabbe39$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';
const $d5b555147cabbe39$export$e792b5b2b6c9ee7 = 'command-palette.ui.modal.body.command-right-icon-container';

parcelRegister("hBQBI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2fa0ed9a30870185$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2fa0ed9a30870185$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rightChevronLabel: {
        "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
        "defaultMessage": "Command with children icon"
    }
});

});

parcelRegister("iMtOt", function(module, exports) {

$parcel$export(module.exports, "Shortcuts", () => $7fcd400f64ed3fa3$export$b326d77e4b8b7664);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ftpwV = parcelRequire("ftpwV");

var $8FbYY = parcelRequire("8FbYY");

var $5t8Df = parcelRequire("5t8Df");


var $ff5gx = parcelRequire("ff5gx");
const $7fcd400f64ed3fa3$var$KeyElement = ({ shortcut: shortcut })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$export$cde89099db64abe3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5t8Df.FilledLozenge), {
        "data-testid": (0, $258bfb6c4afc66c3$export$cd62afa4691c297)
    }, shortcut));
const $7fcd400f64ed3fa3$var$DivisorElement = ({ divisor: divisor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$ShortcutDivider, {
        "data-testid": (0, $258bfb6c4afc66c3$export$e06ad7c09a29974b)
    }, divisor);
/**
 * Transform shortcut string into object
 */ const $7fcd400f64ed3fa3$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
    const replacer = replacers.shift();
    if (!replacer) {
        acc.push({
            type: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY,
            key: shortcut
        });
        types.push((0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY);
        return [
            acc,
            types
        ];
    }
    shortcut.split(replacer.char).forEach((str, index, self)=>{
        $7fcd400f64ed3fa3$var$parseShortcut(str, replacers.slice(0), acc, types);
        if (index < self.length - 1) {
            acc.push({
                type: replacer.replacement
            });
            types.push(replacer.replacement);
        }
    });
    return [
        acc,
        types
    ];
};
const $7fcd400f64ed3fa3$export$cfaeb054b183bb20 = ()=>(0, $5JgJ2.default)();
const $7fcd400f64ed3fa3$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
    const { formatMessage: formatMessage } = $7fcd400f64ed3fa3$export$cfaeb054b183bb20();
    const [shortcuts, types] = (0, $eUqFw.useMemo)(()=>$7fcd400f64ed3fa3$var$parseShortcut(shortcut, (0, $8FbYY.getShortcutSpecialCharacters)()), [
        shortcut
    ]);
    const basicShortcutMessage = (0, $eUqFw.useMemo)(()=>{
        if (types.length === 3) {
            if (types[0] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY) {
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN) return (0, $ff5gx.messages).shortcutThen;
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR) return (0, $ff5gx.messages).shortcutOr;
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS) return (0, $ff5gx.messages).shortcutPlus;
            }
        }
        return null;
    }, [
        types
    ]);
    const formatTypeToMessage = (0, $eUqFw.useCallback)((type)=>{
        switch(type){
            case (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN:
                return formatMessage((0, $ff5gx.messages).divisorThen);
            case (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR:
                return formatMessage((0, $ff5gx.messages).divisorOr);
            default:
                return formatMessage((0, $ff5gx.messages).divisorPlus);
        }
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$ShortcutContainer, {
        "data-testid": (0, $258bfb6c4afc66c3$export$ec8260df4f23714c),
        "aria-hidden": true
    }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
        shortcutA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            shortcut: shortcuts[0].key
        }),
        shortcutB: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            shortcut: shortcuts[2].key
        }),
        divisor: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$DivisorElement, {
                divisor: chunk
            })
    }) : shortcuts.map((obj, index)=>{
        if (obj.type === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            key: index,
            shortcut: obj.key
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$DivisorElement, {
            key: index,
            divisor: formatTypeToMessage(obj.type)
        });
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fcd400f64ed3fa3$var$ShortcutDivider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8otz2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fcd400f64ed3fa3$var$ShortcutContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7fcd400f64ed3fa3$export$cde89099db64abe3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
const $258bfb6c4afc66c3$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $258bfb6c4afc66c3$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $258bfb6c4afc66c3$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';

parcelRegister("ff5gx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9663167573e5dde6$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9663167573e5dde6$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shortcutThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
        "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
    },
    shortcutOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
        "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
    },
    shortcutPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
        "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
    },
    divisorThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
        "defaultMessage": "then"
    },
    divisorOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
        "defaultMessage": "or"
    },
    divisorPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
        "defaultMessage": "+"
    }
});

});


parcelRegister("6gNFs", function(module, exports) {

$parcel$export(module.exports, "useHoverTransitionStep", () => $a5599ff6bbc2ab8e$export$eefd045a02bab4c6);

var $eUqFw = parcelRequire("eUqFw");

var $8YJjX = parcelRequire("8YJjX");

var $guiFP = parcelRequire("guiFP");

var $8FbYY = parcelRequire("8FbYY");

var $cAOzG = parcelRequire("cAOzG");
const $a5599ff6bbc2ab8e$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
    const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $eUqFw.useState)(false);
    const [transitionStep, setTransitionStep] = (0, $eUqFw.useState)((0, $cAOzG.TRANSITION_STEP).INITIAL);
    const timerRef = (0, $eUqFw.useRef)(null);
    const isReducedMotion = (0, $8YJjX.useIsReducedMotion)();
    const commandHasChildren = (0, $8FbYY.hasChildren)(command);
    (0, $eUqFw.useEffect)(()=>{
        setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, [
        command
    ]);
    const startTimerForNextStep = (nextStep, durationMs)=>{
        timerRef.current = setTimeout(()=>{
            setTransitionStep(nextStep);
            timerRef.current = null;
        }, durationMs);
    };
    const handleReducedMotionTransition = (0, $eUqFw.useCallback)(()=>{
        if (isActive) setTransitionStep((0, $cAOzG.TRANSITION_STEP).FINISHED);
        else setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
    }, [
        isActive
    ]);
    const handleWithMotionTransition = (0, $eUqFw.useCallback)(()=>{
        switch(transitionStep){
            case (0, $cAOzG.TRANSITION_STEP).INITIAL:
                if (isActive) {
                    setTransitionStep((0, $cAOzG.TRANSITION_STEP).DELAYING);
                    startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, $cAOzG.TRANSITION_INITIAL_DELAY_TIME_MS) : (0, $cAOzG.TRANSITION_HOVER_DELAY_TIME_MS));
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).DELAYING:
                if (!isActive) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = null;
                    setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).TRANSITIONING:
                if (isActive) {
                    if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                    if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).FINISHED, (0, $cAOzG.TRANSITION_DURATION_MS));
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).FINISHED:
                if (!isActive) setTransitionStep((0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT);
                break;
            case (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, $cAOzG.TRANSITION_HOVER_DELAY_TIME_MS));
                break;
            case (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).INITIAL, (0, $cAOzG.TRANSITION_DURATION_MS));
                break;
            default:
                (0, $guiFP.default)({
                    error: new Error('Invalid transition step for command'),
                    meta: {
                        id: 'useTransitionStep',
                        packageName: 'jiraCommandPalette',
                        teamName: 'deliveroo'
                    }
                });
        }
    }, [
        command.shortcut,
        hasTransitionedFirstCommand,
        isActive,
        isFirstCommand,
        transitionStep
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (commandHasChildren) {
            if (isReducedMotion) handleReducedMotionTransition();
            else handleWithMotionTransition();
        }
    }, [
        commandHasChildren,
        isReducedMotion,
        handleReducedMotionTransition,
        handleWithMotionTransition
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isFirstCommand) setHasTransitionedFirstCommand(false);
    }, [
        isFirstCommand
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    return transitionStep;
};

});
parcelRegister("cAOzG", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_STEP", () => $2290b1f6fafc03ce$export$42d8d7c94c5a11e9);
$parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", () => $2290b1f6fafc03ce$export$82cfc253a6c33f59);
$parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", () => $2290b1f6fafc03ce$export$e092796a9af3633b);
$parcel$export(module.exports, "TRANSITION_DURATION_MS", () => $2290b1f6fafc03ce$export$1cad4f611a1c0229);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $2290b1f6fafc03ce$export$42d8d7c94c5a11e9;
(function(TRANSITION_STEP) {
    TRANSITION_STEP["INITIAL"] = "initial";
    TRANSITION_STEP["DELAYING"] = "delaying";
    TRANSITION_STEP["TRANSITIONING"] = "transitioning";
    TRANSITION_STEP["FINISHED"] = "finished";
    TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
    TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
})($2290b1f6fafc03ce$export$42d8d7c94c5a11e9 || ($2290b1f6fafc03ce$export$42d8d7c94c5a11e9 = {}));
const $2290b1f6fafc03ce$export$82cfc253a6c33f59 = 600;
const $2290b1f6fafc03ce$export$e092796a9af3633b = 300;
const $2290b1f6fafc03ce$export$1cad4f611a1c0229 = 350;

});





parcelRegister("985MX", function(module, exports) {

$parcel$export(module.exports, "CommandRowErrorBoundary", () => $5142cc04bb4fcd8a$export$223f3c3c93a14a83);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $5142cc04bb4fcd8a$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "command-palette-row",
        packageName: "jiraCommandPalette",
        fallback: "unmount",
        teamName: teamName,
        onError: onError,
        attributes: attributes
    }, children);

});

parcelRegister("dDiRc", function(module, exports) {

$parcel$export(module.exports, "GROUP_TEST_ID", () => $1d3aece513b288cb$export$d83f892940e54128);
$parcel$export(module.exports, "NO_RESULTS_TEST_ID", () => $1d3aece513b288cb$export$bf182a53106ca02e);
$parcel$export(module.exports, "SCROLL_DIRECTION", () => $1d3aece513b288cb$export$a6d65a8fb7b912d6);
const $1d3aece513b288cb$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $1d3aece513b288cb$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $1d3aece513b288cb$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
const $1d3aece513b288cb$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
const $1d3aece513b288cb$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
var $1d3aece513b288cb$export$a6d65a8fb7b912d6;
(function(SCROLL_DIRECTION) {
    SCROLL_DIRECTION["START"] = "start";
    SCROLL_DIRECTION["END"] = "end";
})($1d3aece513b288cb$export$a6d65a8fb7b912d6 || ($1d3aece513b288cb$export$a6d65a8fb7b912d6 = {}));

});

parcelRegister("4PPUt", function(module, exports) {

$parcel$export(module.exports, "isElementVisibleInContainer", () => $4d787935cca8e899$export$b9dc8b6556026098);
$parcel$export(module.exports, "getScrollToIndex", () => $4d787935cca8e899$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "scrollResultIntoView", () => $4d787935cca8e899$export$6be8a7238febd54f);

var $8FbYY = parcelRequire("8FbYY");

var $dDiRc = parcelRequire("dDiRc");
const $4d787935cca8e899$export$b9dc8b6556026098 = (element, container)=>{
    const modalBodyRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
};
const $4d787935cca8e899$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
    const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).START && commandResultIndex > 0) {
        // Verify if there is any active command before this id
        const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, $8FbYY.hasAction)(result.command));
        if (prevActiveCommandIndex === -1) return 0;
    }
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).END) {
        // Verify if there is any active command after this id
        const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, $8FbYY.hasAction)(result.command));
        if (afterActiveCommandIndex === -1) return results.length - 1;
        // Scrolling down, so group headings don't need to be taken into account
        return commandResultIndex;
    }
    const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
    return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
};
const $4d787935cca8e899$export$6be8a7238febd54f = (scrollToResult, scrollTo)=>{
    if (!scrollToResult?.parentElement) return;
    const parent = scrollToResult.parentElement;
    const elemRect = scrollToResult.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    const gapScroll = 4;
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).END) {
        const commandPosition = elemRect.bottom - parentRect.top;
        const amountToScroll = commandPosition - parentRect.height;
        const pos = amountToScroll + gapScroll + parent.scrollTop;
        scrollToResult.parentElement.scrollTo({
            top: pos
        });
    } else {
        const commandPosition = parentRect.top - elemRect.top;
        const amountToScroll = parent.scrollTop - commandPosition;
        const pos = amountToScroll - gapScroll;
        scrollToResult.parentElement.scrollTo({
            top: pos
        });
    }
};

});


parcelRegister("b4qUd", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $846e4b3bae55c666$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $846e4b3bae55c666$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
    const footerChildren = children || defaultFooterContent;
    if (!footerChildren) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($846e4b3bae55c666$var$ModalFooter, {
        "data-testid": (0, $933f109161dc97b5$export$aca3e1b45b29f2bb)
    }, footerChildren);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $846e4b3bae55c666$var$ModalFooter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_mrkb1kw7 _1o0z1kw7 _x3doh6cr _1yt49l6b",
            __cmplp.className
        ])
    });
});

});
const $933f109161dc97b5$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';


parcelRegister("48xUp", function(module, exports) {

$parcel$export(module.exports, "Header", () => $3708226beef9cde7$export$8b251419efc915eb);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


const $3708226beef9cde7$export$8b251419efc915eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3708226beef9cde7$var$headerStyles,
        testId: (0, $baf314009244cc15$export$bf5b960a2e79e6cf)
    }, children);
const $3708226beef9cde7$var$headerStyles = (0, $1ZAYh.xcss)({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderBottom: `solid 1px ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N40})`}`
});

});
const $baf314009244cc15$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';



parcelRegister("8A5Pc", function(module, exports) {

$parcel$export(module.exports, "NameContainer", () => $1a80cd2471468c76$export$817b6bdd5f45c94b);
$parcel$export(module.exports, "IconContainer", () => $1a80cd2471468c76$export$8f314e512d92575f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $1a80cd2471468c76$export$817b6bdd5f45c94b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _2lx2vrvc _1nmz1hna _slp31hna",
            __cmplp.className
        ])
    });
});
const $1a80cd2471468c76$export$8f314e512d92575f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _18u012x7 _1bsb1tcg _4t3i1tcg _vwz41tcg _1f027vkz _nbgx7vkz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4HIA6", function(module, exports) {

$parcel$export(module.exports, "NavigationLink", () => $0497a7ba6bc39231$export$721ee963a67379f1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lB25E = parcelRequire("lB25E");
const $0497a7ba6bc39231$export$721ee963a67379f1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1Uuz9", function(module, exports) {

$parcel$export(module.exports, "NewTabHintMessage", () => $16f6fd73a925a670$export$54561b2030abf061);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $LddR2 = parcelRequire("LddR2");

var $5t8Df = parcelRequire("5t8Df");

var $igOBb = parcelRequire("igOBb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1TF2x = parcelRequire("1TF2x");
const $16f6fd73a925a670$export$54561b2030abf061 = ({ defaultFooterContent: defaultFooterContent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LddR2.components).Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$FooterContentContainer, {
        "data-testid": "command-palette-common.common.ui.new-tab-hint-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, defaultFooterContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$HintMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$MessageWrapper, null, formatMessage((0, $1TF2x.messages).openInANewTab)), (0, $igOBb.isMacOs)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$MacLozenge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$MacTextOffset, null, "\u2318")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$WindowsLozenge, null, "Ctrl"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$EnterLozenge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$EnterIconSVG, null)))));
};
const $16f6fd73a925a670$var$EnterIconSVG = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "13",
        height: "8",
        viewBox: "0 0 13 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.055 1.055V3.055H2.275L4.195 1.135C4.455 0.875 4.455 0.455 4.195 0.195C3.935 -0.065 3.515 -0.065 3.255 0.195L0.195 3.255C-0.065 3.515 -0.065 3.935 0.195 4.195L3.255 7.255C3.515 7.515 3.935 7.515 4.195 7.255C4.455 6.995 4.455 6.575 4.195 6.315L2.275 4.38833H11.7217C12.0883 4.38833 12.3883 4.08833 12.3883 3.72167V1.055C12.3883 0.688333 12.0883 0.388333 11.7217 0.388333C11.355 0.388333 11.055 0.688333 11.055 1.055Z",
        fill: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N600})`
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f6fd73a925a670$var$FooterContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f6fd73a925a670$var$HintMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m _syazc8hx _u5f312x7",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$MacLozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5t8Df.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0v77o _k48p1nn1 _1wybf6fq _vwz47vkz _syazc8hx",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$MacTextOffset = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_t9ec170z",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$WindowsLozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5t8Df.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1qjk _k48p1nn1 _1p1d1dk0 _syazc8hx",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$EnterLozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5t8Df.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$MessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c8qk37 _2hwxv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1TF2x", function(module, exports) {

$parcel$export(module.exports, "messages", () => $62b2c63e3a44a01a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $62b2c63e3a44a01a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    openInANewTab: {
        "id": "command-palette-common.common.new-tab-hint-message.open-in-a-new-tab",
        "defaultMessage": "Open in a new tab"
    }
});

});


parcelRegister("duyJV", function(module, exports) {

$parcel$export(module.exports, "isCurrentPage", () => $fc96c12861a877b0$export$d4781f4a7d66b55c);
const $fc96c12861a877b0$export$d4781f4a7d66b55c = (hideCommandPath, pathname)=>{
    const currentPathnameWithoutTrailingSlash = pathname.replace(/\/$/, '');
    const hideCommandPathWithoutTrailingSlash = hideCommandPath?.replace(/\/$/, '');
    return hideCommandPathWithoutTrailingSlash === currentPathnameWithoutTrailingSlash;
};

});

const $f3c17e0f83ec4de3$export$99957d8f5f113509 = 'command-palette-common.controllers.transform-navigation-commands.icon-container';
const $f3c17e0f83ec4de3$export$8db96ea7b6a4cbab = 'command-palette-common.controllers.transform-navigation-commands.navigation-link';


parcelRegister("kAiYS", function(module, exports) {

$parcel$export(module.exports, "ModalsContainer", () => $82008c78277b9b5a$export$5dffa5a5319be22d);
$parcel$export(module.exports, "ModalsSubscriber", () => $82008c78277b9b5a$export$facc296933ebcadf);

var $WBLbN = parcelRequire("WBLbN");

var $eMGrB = parcelRequire("eMGrB");
const $82008c78277b9b5a$export$5dffa5a5319be22d = (0, $WBLbN.createContainer)((0, $eMGrB.default));
const $82008c78277b9b5a$export$facc296933ebcadf = (0, $WBLbN.createSubscriber)((0, $eMGrB.default), {
    displayName: 'ModalsSubscriber',
    selector: (state)=>state.isOpen
});

});
parcelRegister("eMGrB", function(module, exports) {

$parcel$export(module.exports, "default", () => $70da9ac93f6b241a$export$2e2bcd8739ae039);

var $WBLbN = parcelRequire("WBLbN");

var $fjynS = parcelRequire("fjynS");
const $70da9ac93f6b241a$var$initialState = {
    isOpen: false
};
var $70da9ac93f6b241a$export$2e2bcd8739ae039 = (0, $WBLbN.createStore)({
    name: 'modals',
    initialState: $70da9ac93f6b241a$var$initialState,
    actions: $fjynS.default
});

});
parcelRegister("fjynS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d52ffb5755573be$export$2e2bcd8739ae039);
const $4d52ffb5755573be$var$actions = {
    open: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    close: ()=>({ setState: setState })=>{
            setState({
                isOpen: false
            });
        }
};
var $4d52ffb5755573be$export$2e2bcd8739ae039 = $4d52ffb5755573be$var$actions;

});



const $43e5db31f2699c3a$export$e0515b3bb1ce3f33 = 'viewKeyboardShortcuts';
const $43e5db31f2699c3a$export$5f007fc3736b8e2b = 'viewAllIssues';
const $43e5db31f2699c3a$export$4e353cf4f7beb2cd = 'createIssue';
const $43e5db31f2699c3a$export$42dbd0c9d165bb55 = 'getHelp';

parcelRegister("iUV1N", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed06c35ec0ee63b0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ed06c35ec0ee63b0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    globalShortcuts: {
        "id": "keyboard-shortcuts.global-shortcuts",
        "defaultMessage": "Global shortcuts"
    },
    quickSearch: {
        "id": "keyboard-shortcuts.quick-search",
        "defaultMessage": "Quick search"
    },
    closeDrawer: {
        "id": "keyboard-shortcuts.close-drawer",
        "defaultMessage": "Close drawer"
    },
    createIssue: {
        "id": "keyboard-shortcuts.create-issue",
        "defaultMessage": "Create issue"
    },
    keyboardShortcuts: {
        "id": "keyboard-shortcuts.keyboard-shortcuts",
        "defaultMessage": "Keyboard shortcuts"
    },
    keyboardShortcutsCommandPalette: {
        "id": "keyboard-shortcuts.keyboard-shortcuts-command-palette",
        "defaultMessage": "View keyboard shortcuts"
    },
    findIssues: {
        "id": "keyboard-shortcuts.find-issues",
        "defaultMessage": "Find issues"
    },
    browseAProject: {
        "id": "keyboard-shortcuts.browse-a-project",
        "defaultMessage": "Browse to a project"
    },
    toggleSidebar: {
        "id": "keyboard-shortcuts.toggle-sidebar",
        "defaultMessage": "Toggle sidebar"
    },
    openHelpPanel: {
        "id": "keyboard-shortcuts.open-help-panel",
        "defaultMessage": "Open help panel"
    },
    openCommandPalette: {
        "id": "keyboard-shortcuts.open-command-palette",
        "defaultMessage": "Open command palette"
    },
    quickSearchCommand: {
        "id": "keyboard-shortcuts.quick-search-command",
        "defaultMessage": "Open quick search"
    },
    getHelp: {
        "id": "keyboard-shortcuts.get-help",
        "defaultMessage": "Get help"
    },
    viewAllIssues: {
        "id": "keyboard-shortcuts.view-all-issues",
        "defaultMessage": "View all issues"
    }
});

});

parcelRegister("56eCS", function(module, exports) {

$parcel$export(module.exports, "getShortcutModifierKey", () => $0076e2fabf35be6f$export$fe66dae91c68619b);
const $0076e2fabf35be6f$var$isMacOs = ()=>/Mac/i.test(window?.navigator?.platform);
const $0076e2fabf35be6f$export$fe66dae91c68619b = ()=>$0076e2fabf35be6f$var$isMacOs() ? 'meta' : 'ctrl';

});




//# sourceMappingURL=async-keyboard-shortcuts-mapping.f804bd83.js.map
